import type { MouseEvent as ReactMouseEvent } from 'react';
import { openAppPathInNewTab } from './app-navigation';
import { entityDetailHref, type RelatedEntity } from './entity-utils';
import { opensEntityDetailInPlace } from '../contexts/OpenEntityDetailContext';

type OpenEntityDetailFn = (entity: RelatedEntity) => void;

export function handleEntityDetailActivation(
  event: ReactMouseEvent | MouseEvent,
  entity: RelatedEntity,
  projectId: string | undefined,
  openEntityDetail: OpenEntityDetailFn | null | undefined
): boolean {
  const href = entityDetailHref(entity, projectId);
  const metaOrCtrl =
    ('metaKey' in event && event.metaKey) || ('ctrlKey' in event && event.ctrlKey);
  const isMiddleButton = 'button' in event && event.button === 1;

  if (metaOrCtrl || isMiddleButton) {
    if (!href) {
      return false;
    }
    event.preventDefault();
    event.stopPropagation();
    openAppPathInNewTab(href);
    return true;
  }

  if ('button' in event && event.button !== 0 && event.type !== 'click') {
    return false;
  }

  if (openEntityDetail && opensEntityDetailInPlace(entity.type)) {
    event.preventDefault();
    event.stopPropagation();
    if ('stopImmediatePropagation' in event && typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    openEntityDetail(entity);
    return true;
  }

  if (href && event.type === 'click' && !metaOrCtrl) {
    return false;
  }

  return false;
}
